<template>
  <div>
    <h2 class="text-center">
      <a href="#top" class="text-decoration-none">
        ☝️ Scroll to top
      </a>
    </h2>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "ScrollToTop",
});
</script>